// Изменение величины: знак, единица и цвет «к лучшему / к худшему».

import { cn } from '@/lib/cn'

import type { ComparisonRow } from '../api'
import { deltaText, isGood, toneClass } from './deltaFormat'

export function Delta({ delta, row, className }: { delta: number | null; row: ComparisonRow; className?: string }) {
  if (delta === null) return <span className="text-muted">—</span>
  return <span className={cn('tabular-nums', toneClass(isGood(delta, row.better)), className)}>{deltaText(delta, row)}</span>
}
